var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"showroom vrShowroom home",style:({ 'background-image': 'url(images/hintergrund-start.jpg)' })},[_c('selection',{ref:"selection",attrs:{"current":'',"show-selection":true,"show-buttons":false,"home":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }